import * as React from "react";
const SvgFiRrArrowUpFromSquare = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-arrow-up-from-square_svg__a)">
      <path
        fill="#062147"
        d="M5.279 6.693a1 1 0 0 1 .027-1.414L9.893.865c1.105-1.106 3.095-1.12 4.229.014l4.572 4.4a1 1 0 0 1-1.387 1.442L13 2.575V16a1 1 0 0 1-2 0V2.575L6.693 6.721a1 1 0 0 1-1.414-.028M21 8a1 1 0 0 0-1 1v10c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3V9a1 1 0 0 0-2 0v10c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V9a1 1 0 0 0-1-1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-arrow-up-from-square_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrArrowUpFromSquare;
